import cloneDeep from 'lodash/cloneDeep';

import {IDocumentVerification, IFaceMatchValidation, ILivenessValidation, IRegexValidation, IValidation, ValidationType} from '@core/api/data-access';

import {DocumentVerificationValidationModel, FaceMatchValidationModel, LivenessValidationModel, RegexValidationModel} from './validation-types';
import {ValidationModel} from './validation.abstract.model';

export function ValidationModelFactory(validation: IValidation): ValidationModel {
	switch (validation.type) {
		case ValidationType.Liveness:
			const liveness: ILivenessValidation = validation as ILivenessValidation;
			const livenessModel = new LivenessValidationModel();
			livenessModel.originalInstance = cloneDeep(liveness);
			livenessModel.passive = liveness?.passive || false;
			return livenessModel;

		case ValidationType.DocumentVerification:
			const documentVerification: IDocumentVerification = validation as IDocumentVerification;
			const documentVerificationModel = new DocumentVerificationValidationModel(documentVerification.valueToCompareSource);
			documentVerificationModel.countryCodes = documentVerification.countryCodes;
			documentVerificationModel.documentType = documentVerification.documentType;

			documentVerificationModel.originalInstance = cloneDeep(documentVerification);
			return documentVerificationModel;

		case ValidationType.FaceMatch:
			const faceMatch: IFaceMatchValidation = validation as IFaceMatchValidation;
			const faceMatchModel = new FaceMatchValidationModel(faceMatch.imageToCompare);
			faceMatchModel.originalInstance = cloneDeep(faceMatch);

			faceMatchModel.imageData = faceMatch.imageData;
			return faceMatchModel;

		case ValidationType.Regex:
			const regex: IRegexValidation = validation as IRegexValidation;
			const regexModel = new RegexValidationModel();
			regexModel.key = regex.key;
			regexModel.originalInstance = cloneDeep(regex);
			return regexModel;
	}
}
